<div class="modal-content">
    <div class="modal-header modal-header-color-aggrement">
        <div class="modal-title h4" id="example-modal-sizes-title-lg">
            <ng-container>
                User Agreement
            </ng-container>
        </div>
    </div>
    <div class="modal-body">
        <a href="#" id="scroll_to_top_id"></a>
        <ng-container>
            <div [innerHTML]="agreementData">
            </div>
        </ng-container>
    </div>
    <div class="modal-footer">
        <div>
            <button type="button" class="btn btn-light btn-elevate mr-1" (mousedown)="close()">
                Cancel
            </button>&nbsp;
            <button type="button" class="btn btn-primary btn-elevate" (click)="AgreeTerms()">
                Agree
            </button>
        </div>
    </div>
</div>